import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ReactComponent as PlusCircle } from '../../../assets/icons/add-circle.svg'
import { useLookupStore } from '../../../stores/lookUpStore'
import NotFound from '../../NotFound/NotFound'

import AddRegex from './AddRegex/AddRegex'
import Regex from './Regex/Regex'

import styles from './regex-table.module.scss'

function RegexTable() {
    const { t } = useTranslation()

    const [{ regexes }] = useLookupStore()

    const [isAddingNewRegex, setIsAddingNewRegex] = useState(false)

    return (
        <div className={styles.regexTable}>
            <div className={styles.regexTable__regexes}>
                <div className={styles.regexTable__head}>
                    <div className={styles.regexTable__headContent}>
                        <div className={styles.regexTable__headName}>
                            {t('name')}
                            <button
                                className={styles.regexTable__addRegexBtn}
                                onClick={() =>
                                    setIsAddingNewRegex(
                                        (isAddingRegex) => !isAddingRegex
                                    )
                                }
                            >
                                <PlusCircle
                                    className={
                                        styles.nluDataExamples__addExampleIcon
                                    }
                                />
                                {t('add_new')}
                            </button>
                        </div>
                        <div className={styles.regexTable__headPattern}>
                            {t('pattern')}
                        </div>
                    </div>
                </div>
                <div className={styles.regexTable__results}>
                    {regexes.length ? (
                        <p>
                            {regexes.length} {t('results')}
                        </p>
                    ) : null}
                </div>
                {isAddingNewRegex && <AddRegex />}
                {regexes.length ? (
                    regexes?.map((regex) => (
                        <Regex key={regex._id} regex={regex} />
                    ))
                ) : (
                    <NotFound title={t('no_regex')} />
                )}
            </div>
        </div>
    )
}

export default RegexTable
